// Base
import { DetailedHTMLProps, HTMLAttributes } from 'react'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/router'
import { UrlObject } from 'url'

// Packages
import { Link } from 'react-scroll'

// Components
import { Box, Flex, Text } from 'yard-utilities/components'
import NextLink from './next-link/NextLink'

// Styles
import styles from './Navigation.module.sass'

interface NavigationProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  active: boolean
  closeMenu: () => void
}

const Navigation = ({ active, closeMenu, ...rest }: NavigationProps) => {
  const pathname = usePathname()
  const router = useRouter()

  const handleClick = (section: string) => {
    if (!pathname?.includes('home')) {
      router.push(`/v25/home#${section}`)
    }

    closeMenu()
  }

  return (
    <nav className={`${styles.nav} ${active ? styles.active : ''}`} {...rest}>
      <Box backgroundColor="grey-5">
        <Flex flexDirection="column" rowGap={{ sm: 1 }}>
          <NavLink
            id="recent-deals-anchor"
            onClick={() => handleClick('recent-deals-anchor')}
          >
            Recent deals
          </NavLink>
          <NavLink
            id="how-it-works-anchor"
            onClick={() => handleClick('how-it-works-anchor')}
          >
            How it works
          </NavLink>

          <NavLink
            id="experiences-anchor"
            onClick={() => handleClick('experiences-anchor')}
          >
            Experiences
          </NavLink>
          <NavLink
            id="reviews-anchor"
            onClick={() => handleClick('reviews-anchor')}
          >
            Reviews
          </NavLink>
          <NavLink id="faq-anchor" onClick={() => handleClick('faq-anchor')}>
            FAQ
          </NavLink>

          <NavLink href="/v25/membership">Sign up</NavLink>
        </Flex>
      </Box>
    </nav>
  )
}

interface NavLinkProps {
  children: React.ReactNode
  id?: string
  onClick?: () => void
  href?: string | UrlObject
}

const NavLink = ({ children, id, onClick, href }: NavLinkProps) => {
  return (
    <NavWrapper id={id} href={href} onClick={onClick}>
      <Box backgroundColor="white" padding={{ sm: [16] }}>
        <Text variant="body-1" transform="uppercase" fontWeight={500}>
          {children}
        </Text>
      </Box>
    </NavWrapper>
  )
}

interface NavWrapperProps {
  href?: string | UrlObject
  id?: string
  onClick?: () => void
  children: React.ReactNode
}

const NavWrapper = ({ href, id, onClick, children }: NavWrapperProps) => {
  if (href) {
    return <NextLink href={href}>{children}</NextLink>
  }

  if (id) {
    return (
      <Link to={id} onClick={onClick}>
        {children}
      </Link>
    )
  }

  return <div>{children}</div>
}

export default Navigation
